export default __webpack_public_path__ + "static/media/after.836c9f67.svg";